import axios from "axios";

const BACKEND_URI = process.env.REACT_APP_BACKEND_URI || "";

export const api = token => {
  const headers = {
    "ngrok-skip-browser-warning": "true",
    ...(typeof token === "string" &&
      token.split(".").length === 3 && {
        Authorization: token
      })
  };

  return axios.create({
    baseURL: BACKEND_URI,
    headers
  });
};

export const handleResponse = res => {
  if (!res.data) {
    return Promise.reject(new Error("No data in response"));
  }

  if (res.data.error) {
    const error = res.data.message || res.data.error;
    return Promise.reject(error);
  }

  return res.data;
};

export const handleError = err => {
  if (!err.response) {
    console.error("Network error:", err);
    return Promise.reject(new Error("Network error"));
  }

  if (err.response.status === 401) {
    localStorage.setItem("isLogin", "false");
    localStorage.removeItem("accessToken");

    // Properly clear cookie
    document.cookie =
      "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=strict";

    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }

  return Promise.reject(err.response.data || err.message);
};
